<template>
  <div class="pagesBox">
    <!-- <div style="height: 60px; width: 100%"></div> -->

    <div class="formbox">
      <el-form
        :model="rightForm"
        :rules="rules"
        ref="rightFormRef"
        label-width="120px"
        class="glo_formBox"
      >
        <div class="teSu">
          <el-form-item label="运单号:" prop="waybillNumber">
            <el-input
              v-model="rightForm.waybillNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-button class="glo_bgcMainColor formBtns" @click="getData()"
            >搜索</el-button
          >
        </div>
        <el-form-item label="任务类型:" prop="transportType">
          <el-select
            v-model="rightForm.transportType"
            placeholder="请选择"
            @change="changeTransportType"
          >
            <el-option
              v-for="item in transportTypeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="任务运输方式:" prop="transportMethod">
          <el-select
            clearable
            v-model="rightForm.transportMethod"
            placeholder="请选择"
          >
            <el-option
              v-for="item in transportMethodStatus"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="外部承运商:"
          prop="externalCarrierName"
          v-if="
            rightForm.transportMethod === 'wai_bu_cheng_yun:transport_method'
          "
        >
          <el-select
            clearable
            filterable
            v-model="rightForm.externalCarrierName"
            placeholder="请选择"
            @change="changecarrierName"
          >
            <el-option
              v-for="(item, index) in changeCarrierList"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          style="width: 380px"
          label="运输计划:"
          prop="transportPlan"
        >
          <el-radio-group
            v-model="rightForm.transportPlan"
            @change="changetransportPlan"
          >
            <el-radio
              v-for="(item, index) in transportPlanList"
              :key="index"
              :label="item.statusVal"
              >{{ item.showName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="入仓仓库:"
          prop="storageId"
          v-if="rightForm.transportPlan === 'ru_cang:transport_plan'"
        >
          <el-select
            clearable
            filterable
            v-model="rightForm.storageId"
            placeholder="请选择"
            @change="changeRuCang"
          >
            <el-option
              v-for="(item, index) in storageList"
              :key="index"
              :label="item.departmentName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="外发承运商:"
          prop="carrierName"
          v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
        >
          <el-select
            clearable
            filterable
            v-model="rightForm.carrierName"
            placeholder="请选择"
            @change="changecarrierName2"
          >
            <el-option
              v-for="(item, index) in changeCarrierList"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierName"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="外发网点:"
          v-if="rightForm.transportPlan === 'wai_fa:transport_plan'"
          prop="carrierDeptId"
        >
          <el-select
            clearable
            filterable
            v-model="rightForm.carrierDeptId"
            placeholder="请选择"
            @change="changeCarrierDep"
          >
            <el-option
              v-for="(item, index) in CarrierDeptListList"
              :key="index"
              :label="item.deptName"
              :value="item.carrierDeptId"
            ></el-option>
          </el-select>
        </el-form-item>

        <div v-if="rightForm.transportPlan === 'zhi_song:transport_plan'">
          <!-- 直送 -->
          <el-form-item label="目的地址" style="width: 100%">
            <el-input
              placeholder="对应运单的收货地址"
              type="text"
              readonly
            ></el-input>
          </el-form-item>
        </div>

        <!-- 目的地 -->
        <div
          v-if="rightForm.transportPlan !== 'zhi_song:transport_plan'"
          style="width: 100%"
        >
          <!-- <el-form-item label="目的地址:" style="width: 100%">
            <el-input
              placeholder="自动获取地址"
              readonly
              clearable
              v-model="rightForm.addressAll"
              type="textarea"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="目的地址:"
            prop="自动获取地址"
          >
            <el-input
              placeholder="自动获取地址"
              clearable
              v-model="rightForm.addressAll"
              type="textarea"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="aaa"
        >
          <el-input
            placeholder="请输入"
            clearable
            v-model="rightForm.remarks"
            type="textarea"
          ></el-input>
        </el-form-item>
        <!-- 
        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="aaa"
        >
          <el-input type="textarea" rows="3" v-model="rightForm.aaa"></el-input>
        </el-form-item> -->
      </el-form>
      <!-- 内部仓配送仓库 -->
      <el-form
        v-if="rightForm.transportType == 'nei_bu_cang_pei_song:transport_type'"
        :model="queryData3"
        class="glo_form"
        label-position="left"
      >
        <el-form-item class="queryItems" label="配送仓库:">
          <el-select
            filterable
            clearable
            v-model="queryData3.storageId"
            placeholder="请输入"
            @change="changeStorage"
          >
            <el-option
              v-for="item in storageList"
              :key="item.deptId"
              :label="item.departmentName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 外部仓配送承运商和网点 -->
      <el-form
        v-if="rightForm.transportType == 'wai_bu_cang_pei_song:transport_type'"
        :model="queryData3"
        class="glo_form"
        label-position="left"
      >
        <el-form-item class="queryItems" label="承运商:">
          <el-select
            filterable
            clearable
            v-model="queryData3.carrierId"
            placeholder="请输入"
            @change="changecarrierName3"
          >
            <el-option
              v-for="(item, index) in changeCarrierList"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="网点:">
          <el-select
            filterable
            clearable
            v-model="queryData3.carrierDeptId"
            placeholder="请输入"
            @change="changeCarrierDeptName"
          >
            <el-option
              v-for="(item, index) in CarrierDeptListList2"
              :key="index"
              :label="item.deptName"
              :value="item.carrierDeptId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submitBtns()"
        >生成任务</el-button
      >
    </div>

    <div class="glo_Table" style="margin-bottom: 20px">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column fixed="left" align="center" label="操作" width="80">
          <template slot-scope="scope">
            <!-- <el-button @click="delRow(scope.row)">删除</el-button> -->
            <div
              @click="delRow(scope.row)"
              style="color: #f00; cursor: pointer"
            >
              删除
            </div>
          </template>
        </el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>

      <!-- 分页 -->
      <paging
        ref="pags"
        :pageNum="pageStart1"
        :total="pageCount1"
        :size="pageTotal1"
        @handleSizeChange="handleSizeChange1"
        @handleCurrentChange="handleCurrentChange1"
      >
      </paging>
    </div>
  </div>
</template>
<script>
// import uploadimgs from "@/components/upLoadImgs.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: { paging },
  data() {
    return {
      pageStart1: 1, //  页码
      pageCount1: 0, //  总条数
      pageTotal1: 50, //  一页几条

      totalArr: [], //  表格需要合计的字段
      rightForm: {
        transportMethod: "qi_yun_pai_che:transport_method",
        transportPlan: "zhi_song:transport_plan",
        carrierId: "",
        carrierName: "",
        externalCarrierName: "",
        externalCarrierId: "",
        address: "",
        areaName: "",
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        cityName: "",
        company: "",
        contacts: "",
        phone: "",
        provinceName: "",
        remarks: "",
        storageId: "",
        storageName: "",
        tel: "",
        addressAll: "",

        //
        transportType: "",
        waybillNumber: "",
      },
      fileNameLists2: [],
      tableData: [],
      rules: {
        waybillNumber: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        transportMethod: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        transportType: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        transportPlan: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        storageId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        carrierName: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        carrierDeptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
      CustomerList: [],
      transportTypeList: [
        {
          name: "提货",
          value: "ti_huo:transport_type",
        },
        {
          name: "内部仓配送",
          value: "nei_bu_cang_pei_song:transport_type",
        },
        {
          name: "外部仓配送",
          value: "wai_bu_cang_pei_song:transport_type",
        },
      ],
      transportMethodStatus: [],
      transportPlanList: [],
      transportMethodStatus: [],
      changeCarrierList: [], //承运商列表
      OnwayStatusList: [],
      waybillStatusList: [], //运单状态
      CarrierDeptListList: [], //外发网点
      tableHeigth: "53vh", //  表格高度

      tabelHeadeTitle: [
        {
          name: "任务编号",
          field: "number",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "190",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      
        {
          name: "任务运输方式",
          field: "transportMethodShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      
        {
          name: "状态",
          field: "taskStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物",
          field: "huoWu",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户单号",
          field: "customerOrderNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户编号",
          field: "customerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "入仓仓库",
          field: "intoStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外部运输承运商",
          field: "carrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商",
          field: "outgoingCarrierName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "外发承运商网点",
          field: "outgoingDeptName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货时间",
          field: "takeTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "交货日期",
          field: "deliveryTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货地址",
          field: "taskStartAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车批次号",
          field: "dispatchNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "车牌号",
          field: "carNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "挂车号码",
          field: "trailerNumber",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "司机",
          field: "driverName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "押运员",
          field: "supercargoName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发车合同号",
          field: "dispatchContractNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货时间",
          field: "loadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "装货操作人",
          field: "loadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货时间",
          field: "unloadTime",
          width: "160",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货操作人",
          field: "unloadUserName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "退单状态",
          field: "chargebackStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "退单原因",
          field: "chargebackReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "是否回仓",
          field: "returnCangStatusShow",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓原因",
          field: "returnCangReason",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "回仓仓库",
          field: "returnCangStorageName",
          width: "106",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],

      myTableHeard: [], //  我的表头(提货)
      queryData3: {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        storageId: "",
        storageName: "",
      },
      waybillSplitId: "",
      CarrierDeptListList2: [],
      takeAddids: [],
    };
  },
  watch: {},
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
  },
  mounted() {
    this.getStatusValList("bill_tms_transport_task_v3.transport_method"); //运输方式
    this.getStatusValList("bill_tms_transport_task_v3.transport_plan"); //运输方式
    this.changeCarrier(); // 承运商列表
    this.getDeptList(); //获取仓库列表
  },
  activated() {
    let waybillNumber = this.$route.query.waybillNumber || "";
    let waybillSplitId = this.$route.query.waybillSplitId || "";

    if (waybillNumber) {
      this.rightForm.waybillNumber = waybillNumber;

      this.getData();
    }
    if (waybillSplitId) {
      this.waybillSplitId = waybillSplitId;
    }
  },
  destroyed() {},
  methods: {
    changeStorage(e) {
      console.log(e);
      this.storageList.forEach((item) => {
        if (item.deptId == e) {
          this.queryData3.storageName = item.departmentName;
        }
      });
    },
    // 登录账号的承运商(外部)
    changecarrierName3(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierId == e) {
            this.queryData3.carrierName = item.carrierName;
            this.getCarrierDeptList2(e);
          }
        });
      } else {
        this.queryData3.carrierName = "";
        this.queryData3.carrierDeptName = "";
        this.queryData3.carrierDeptId = "";
      }
    },
    // 获取承运商网点
    getCarrierDeptList2(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList2 = res || [];
        if (this.CarrierDeptListList2.length > 0) {
          this.queryData3.carrierDeptId =
            this.CarrierDeptListList2[0].carrierDeptId;
          this.queryData3.carrierDeptName =
            this.CarrierDeptListList2[0].deptName;
        }
      });
    },
    // 登录账号的承运商默认网点
    changeCarrierDeptName(e) {
      if (e) {
        this.CarrierDeptListList2.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.queryData3.carrierDeptName = item.deptName;
          }
        });
      } else {
        this.queryData3.carrierDeptName = "";
      }
    },
    delRow(row) {
      this.$confirm("是否对所选任务进行删除操作?请谨慎操作", "提示:")
        .then(() => {
          let ids = [row.taskId];
          this.$API.wtl_delTask({ taskIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch(() => {});
    },

    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    // 点击选中当前行
    rowclick2(row, event, column) {
      this.$refs.mytable2.toggleRowSelection(row);
    },

    handleSelectionChange2(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 选择入仓仓库
    changeRuCang(e) {
      console.log("e", e);
      if (e) {
        this.storageList.forEach((item) => {
          if (item.deptId == e) {
            this.rightForm.storageName = item.departmentName || "";

            this.rightForm.address = item.address || "";
            this.rightForm.areaName = item.areaName || "";
            this.rightForm.cityName = item.cityName || "";
            this.rightForm.provinceName = item.provinceName || "";
            this.rightForm.addressAll =
              item.provinceName + item.cityName + item.areaName + item.address;
          }
        });
      } else {
        this.rightForm.address = "";
        this.rightForm.areaName = "";
        this.rightForm.cityName = "";
        this.rightForm.provinceName = "";
        this.rightForm.addressAll = "";
      }
    },
    // 获取仓库列表
    getDeptList() {
      let param = {
        pageStart: 1,
        pageTotal: 200,
        isStorage: "1",
      };
      this.$API.wtl_getDeptList(param).then((res) => {
        this.storageList = res.data.result.data || [];

        // 登录账号的信息
        let userdata = this.$TOOLS.getUserInfo() || "";
        if (userdata) {
          this.storageList.forEach((item) => {
            if (userdata.departmentId == item.deptId) {
              this.queryData3.storageId = userdata.departmentId || "";
              this.queryData3.storageName = userdata.storageName || "";
            }
          });
        }
      });
    },
    // 承运商列表
    changeCarrier(e) {
      this.$COMAPI.changeCarrier(e).then((res) => {
        this.changeCarrierList = res || [];
      });
    },
    // 选择承运商(外发)
    changecarrierName2(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.rightForm.carrierId = item.carrierId;
            this.getCarrierDeptList(item.carrierId);
          }
        });
      } else {
        this.rightForm.carrierDeptId = "";
        this.rightForm.carrierId = "";
        this.rightForm.addressAll = "";
      }
    },
    // 获取承运商网点
    getCarrierDeptList(id) {
      this.$COMAPI.CarrierDeptList(id).then((res) => {
        this.CarrierDeptListList = res || [];
      });
    },
    // 选择外发网点获取地址
    changeCarrierDep(e) {
      if (e) {
        this.CarrierDeptListList.forEach((item) => {
          if (item.carrierDeptId == e) {
            this.rightForm.address = item.address || "";
            this.rightForm.areaName = item.areaName || "";
            this.rightForm.cityName = item.cityName || "";
            this.rightForm.provinceName = item.provinceName || "";
            this.rightForm.addressAll =
              item.provinceName + item.cityName + item.areaName + item.address;
          }
        });
      } else {
        this.rightForm.address = "";
        this.rightForm.areaName = "";
        this.rightForm.cityName = "";
        this.rightForm.provinceName = "";
        this.rightForm.addressAll = "";
      }
    },
    // 选择任务类型
    changeTransportType(e) {
      if (e == "ti_huo:transport_type") {
        this.$API
          .wtl_getWaybillTakeAddr({ waybillSplitId: this.waybillSplitId })
          .then((res) => {
            this.takeAddids = res.data.result || [];
          });
      }
    },
    // 选择承运商(外部)
    changecarrierName(e) {
      if (e) {
        this.changeCarrierList.forEach((item) => {
          if (item.carrierName == e) {
            this.rightForm.externalCarrierId = item.carrierId;
          }
        });
      }
    },
    // 选择运输方式
    changetransportPlan(e) {
      console.log("e", e);

      this.rightForm.address = "";
      this.rightForm.areaName = "";
      this.rightForm.cityName = "";
      this.rightForm.provinceName = "";
      this.rightForm.addressAll = "";

      this.rightForm.carrierDeptId = "";
      this.rightForm.storageId = "";
    },
    // 各种状态下拉列表接口
    getStatusValList(type) {
      this.$TOOLS.getStatusValList(type).then((res) => {
        // 运输方式
        if (type == "bill_tms_transport_task_v3.transport_method") {
          this.transportMethodStatus = res || [];
        }
        // 运输计划
        if (type == "bill_tms_transport_task_v3.transport_plan") {
          this.transportPlanList = res || [];
        }
        // 运输计划
        if (type == "bill_tms_waybill_split_v3.waybill_status") {
          this.waybillStatusList = res || [];
        }
      });
    },
    // 生成任务
    submitBtns() {
      let endAddrReq = JSON.parse(JSON.stringify(this.rightForm)) || {};

      // 提货地址
      let startAddrReq = {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        storageId: "",
        storageName: "",
      };

      let waybillIdReqs = [];
      let transportType = this.rightForm.transportType;

      if (transportType == "nei_bu_cang_pei_song:transport_type") {
        // 内部仓配送
        if (!this.queryData3.storageId) {
          this.$message.error("请选择配送仓库");
          return false;
        }
        startAddrReq.storageId = this.queryData3.storageId;
        startAddrReq.storageName = this.queryData3.storageName;
        startAddrReq.carrierDeptId = "";
        startAddrReq.carrierDeptName = "";
        startAddrReq.carrierId = "";
        startAddrReq.carrierName = "";
      } else if (transportType == "wai_bu_cang_pei_song:transport_type") {
        // 外部仓配送
        if (!this.queryData3.carrierId) {
          this.$message.error("请选择承运商");
          return false;
        }
        if (!this.queryData3.carrierDeptId) {
          this.$message.error("请选择承运商网点");
          return false;
        }

        startAddrReq.storageId = "";
        startAddrReq.storageName = "";
        startAddrReq.carrierDeptId = this.queryData3.carrierDeptId;
        startAddrReq.carrierDeptName = this.queryData3.carrierDeptName;
        startAddrReq.carrierId = this.queryData3.carrierId;
        startAddrReq.carrierName = this.queryData3.carrierName;
      }

      if (transportType == "ti_huo:transport_type") {
        //
        this.takeAddids.forEach((item) => {
          let objs = {
            addrId: item.addrId,
            waybillSplitId: this.waybillSplitId || "",
          };
          waybillIdReqs.push(objs);
        });
      } else {
        let objs = {
          addrId: "",
          waybillSplitId: this.waybillSplitId || "",
        };
        waybillIdReqs.push(objs);
      }

      let param = {
        endAddrReq: endAddrReq, //目的地址
        startAddrReq: startAddrReq, //提货地址(仓配送时有值)
        waybillIdReqs: waybillIdReqs, //运单信息
        transportType: transportType, //运输类型
      };

      this.$API.wtl_createTask(param).then((res) => {
        this.$message.success(
          res.data.message || "生成任务成功"
        ).showClose = true;
        this.getData();
      });
    },

    // 提货
    getData() {
      if (!this.rightForm.waybillNumber) {
        this.$message.warning("请输入运单号");
        return false;
      }
      let param1 = {
        waybillNumberNoLike: this.rightForm.waybillNumber,
      };

      this.$API.wtl_getTaskList(param1).then((res) => {
        this.tableData = res.data.result.data || [];
        this.pageCount1 = res.data.result.pageCount;
      });
    },

    handleSizeChange1(val) {
      //  分页
      this.pageTotal1 = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      //  分页
      this.pageStart1 = val;
      this.getData();
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  // position: fixed;
  // z-index: 10;
  // top: 60px;
  // left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.radioList {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>